import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=fab56eb8&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=fab56eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab56eb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fab56eb8')) {
      api.createRecord('fab56eb8', component.options)
    } else {
      api.reload('fab56eb8', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=fab56eb8&scoped=true&", function () {
      api.rerender('fab56eb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JYZa1XPWxKJL/JS/comp/Voucher.vue"
export default component.exports